// Crockford base32 without the ambiguous I, L, O, U. 32^9 ≈ 3.5e13 codes.
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const CODE_LEN = 9;

export function generateJoinCode(rand: () => number = secureRandom): string {
  let raw = "";
  for (let i = 0; i < CODE_LEN; i++) raw += ALPHABET[Math.floor(rand() * ALPHABET.length)];
  return format(raw);
}

/** Accepts any casing, with or without dashes/spaces. Returns `XXX-XXX-XXX` or null. */
export function normalizeJoinCode(input: string): string | null {
  const raw = input.toUpperCase().replace(/[\s-]/g, "");
  if (raw.length !== CODE_LEN) return null;
  for (const ch of raw) if (!ALPHABET.includes(ch)) return null;
  return format(raw);
}

function format(raw: string): string {
  return `${raw.slice(0, 3)}-${raw.slice(3, 6)}-${raw.slice(6, 9)}`;
}

function secureRandom(): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0]! / 2 ** 32;
}
